module.exports = __webpack_public_path__ + "static/media/clients-import-excel-example.c85df128.png";